// @flow
import * as React from 'react';
import { withLeaflet } from 'react-leaflet';
import type { LeafletContext } from 'react-leaflet/lib/types';


type Props = {
    leaflet: LeafletContext,
    children: React.Node,
    minZoom?: number,
    maxZoom?: number,
}

type State = {
    visible: boolean,
}


@withLeaflet
class ZoomRestricted extends React.PureComponent<Props, State> {
    static defaultProps = {
        minZoom: undefined,
        maxZoom: undefined,
        leaflet: {},
    };

    constructor(props: Props) {
        super(props);

        this.state = {
            visible: this._calcVisible(),
        };
    }

    componentDidMount() {
        const { leaflet: { map } } = this.props;

        if (map) {
            map.on('zoomend', this._handleZoomEnd);
        }
    }

    componentWillUnmount() {
        const { leaflet: { map } } = this.props;

        if (map) {
            map.off('zoomend', this._handleZoomEnd);
        }
    }

    _calcVisible = () => {
        const { leaflet: { map }, minZoom, maxZoom } = this.props;

        let visible = !!map;

        if (map) {
            const level = map.getZoom();

            if (typeof minZoom !== 'undefined' && level < minZoom) {
                visible = false;
            }
            if (typeof maxZoom !== 'undefined' && level > maxZoom) {
                visible = false;
            }
        }

        return visible;
    };

    _handleZoomEnd = () => {
        this.setState({
            visible: this._calcVisible(),
        });
    };

    render() {
        const { children } = this.props;
        const { visible } = this.state;

        if (visible) {
            return children;
        }

        return null;
    }
}

export default ZoomRestricted;
